import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { LabelState } from '../../types'

export const createLabelAction = createAsyncAction(
  '@chat/CREATE_LABEL_REQUEST',
  '@chat/CREATE_LABEL_SUCCESS',
  '@chat/CREATE_LABEL_FAILURE'
)<Request, Success, Failure>()

const request = (state: LabelState, action: ActionType<typeof createLabelAction.request>): LabelState => ({
  ...state,
  isLoadingCreateLabel: true
})

const success = (state: LabelState, action: ActionType<typeof createLabelAction.success>): LabelState => {
  const newLabel = action.payload

  return {
    ...state,
    labels: [...state.labels, newLabel],
    isLoadingCreateLabel: false,
    isSuccessOnCreateLabel: true
  }
}
const failure = (state: LabelState, action: ActionType<typeof createLabelAction.failure>): LabelState => ({
  ...state,
  isLoadingCreateLabel: false,
  isErrorOnCreateLabel: true
})

export const createLabelHandle = { asyncAction: createLabelAction, request, success, failure }
